<template>
  <div>
    <b-modal
      id="modal-status"
      size="md"
      centered
      title="Ubah Status"
      header-bg-variant="primary"
      header-text-variant="light"
      hide-footer
    >
      <CRow class="p-3">
        <CCol col="6">
          <b-button
            variant="success"
            class="w-100 mx-1"
            v-c-tooltip.hover.click="'Terima Pengajuan Lembur'"
            @click="changeStatus('1')"
          >Setuju</b-button>
        </CCol>
        <CCol col="6">
          <b-button
            variant="danger"
            class="w-100 mx-1"
            v-c-tooltip.hover.click="'Tolak Pengajuan Lembur'"
            @click="changeStatus('2')"
          >Tolak</b-button>
        </CCol>
      </CRow>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "modalDelete",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Ya",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  methods: {
    changeStatus(status) {
      let vm = this;
      vm.button = this.$store.state.form.tunggu;
      vm.$axios
        .post("pengajuanLembur/update", {
          ...vm.data, 
          id: vm.data.pengajuanLemburId,
          statusPengajuan: status
        }).then((res) => {
          if (res.data.message == "sukses") {
            vm.button = vm.$store.state.form.ya;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGUBAH STATUS PENGAJUAN LEMBUR",
              showing: true,
            });
            this.$bvModal.hide("modal-status");
          } else {
            vm.button = vm.$store.state.form.ya;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = vm.$store.state.form.ya;
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
  },
  watch: {
    lang: function (val) {
      val;
      this.button = this.$store.state.form.ya;
    },
  },
};
</script>
